import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase URL or Anon Key is missing. Please check your .env file.');
}

// Log current environment (safe part of URL)
console.log('Connecting to Supabase project:', supabaseUrl.split('//')[1]?.split('.')[0] || 'Unknown');

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
